'use client';

import * as LabelPrimitive from '@radix-ui/react-label';
import { cn } from '@workspace/ui/lib';
import type * as React from 'react';

function Label({ className, ...props }: React.ComponentProps<typeof LabelPrimitive.Root>) {
  return (
    <LabelPrimitive.Root
      data-slot="label"
      className={cn(
        'text-primary group-data-[disabled=true]:text-grey-300 dark:has-[+:disabled]:text-grey-900 has-[+:disabled]:text-grey-300 flex items-center gap-2 text-sm leading-none font-medium select-none group-data-[disabled=true]:pointer-events-none dark:text-neutral-100',
        className
      )}
      {...props}
    />
  );
}

export { Label };
